<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>系统通知</h1>
        <p>点击一条通知即可查看全文，并记为当前账号已读。未读数会同步到左侧菜单。</p>
      </div>
      <button class="ch-btn" type="button" :disabled="!unread || busy" @click="markAll">全部标为已读</button>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">未读</div><div class="v">{{ unread }} 条</div></div>
      <div class="ch-metric"><div class="k">全部通知</div><div class="v">{{ list.length }} 条</div></div>
      <div class="ch-metric"><div class="k">保证金</div><div class="v">{{ count('保证金') }} 条</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <select v-model="kind">
          <option value="">类型：全部</option>
          <option value="保证金">保证金</option>
          <option value="协议">协议</option>
          <option value="培训">培训</option>
          <option value="结算">结算</option>
          <option value="公告">公告</option>
        </select>
        <select v-model="readFilter">
          <option value="">状态：全部</option>
          <option value="unread">未读</option>
          <option value="read">已读</option>
        </select>
      </div>
      <table class="ch-table">
        <thead><tr><th>时间</th><th>类型</th><th>内容</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in shown" :key="row.noticeKey || row.createdAt + row.title" class="ch-click" @click="openRow(row)">
            <td>{{ row.createdAt }}</td>
            <td><span class="ch-tag">{{ kindOf(row) }}</span></td>
            <td>
              <b :class="{ 'ch-unread': !row.read }">{{ row.title }}</b>
              <div class="ch-note" style="margin-top:6px">{{ row.body }}</div>
            </td>
            <td><span class="ch-tag" :class="row.read ? 'ok' : 'warn'">{{ row.read ? '已读' : '未读' }}</span></td>
          </tr>
          <tr v-if="!shown.length"><td colspan="4" class="ch-empty">没有通知</td></tr>
        </tbody>
      </table>
    </div>

    <el-dialog :title="current.title || '通知'" :visible.sync="open" width="480px" append-to-body @closed="current = {}">
      <p class="ch-note">{{ current.createdAt }} · {{ kindOf(current) }}</p>
      <p class="notice-body">{{ current.body }}</p>
      <span slot="footer">
        <button v-if="current.noticeKey && !current.read" class="ch-btn gold" type="button" :disabled="busy" @click="mark(current)">标为已读</button>
        <button class="ch-btn" type="button" @click="open = false">关闭</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelNotices, readChannelNotice } from '@/api/admin'

export default {
  name: 'PartnerNotices',
  data() {
    return { list: [], kind: '', readFilter: '', open: false, current: {}, busy: false }
  },
  computed: {
    shown() {
      return this.list.filter(item => {
        if (this.kind && this.kindOf(item) !== this.kind) return false
        if (this.readFilter === 'unread' && item.read) return false
        if (this.readFilter === 'read' && !item.read) return false
        return true
      })
    },
    unread() {
      return this.list.filter(item => !item.read).length
    }
  },
  created() { this.load() },
  methods: {
    kindOf(row) {
      const text = ((row && row.title) || '') + ((row && row.body) || '')
      if (text.indexOf('保证金') >= 0) return '保证金'
      if (text.indexOf('协议') >= 0 || text.indexOf('合同') >= 0) return '协议'
      if (text.indexOf('培训') >= 0 || text.indexOf('课程') >= 0) return '培训'
      if (text.indexOf('结算') >= 0) return '结算'
      return '公告'
    },
    count(kind) { return this.list.filter(item => this.kindOf(item) === kind).length },
    apply(result) {
      this.list = (result && result.list) || []
      if (this.current && this.current.noticeKey) {
        const fresh = this.list.find(item => item.noticeKey === this.current.noticeKey)
        if (fresh) this.current = fresh
      }
      const parent = this.$parent
      if (parent && typeof parent.setNoticeCount === 'function') parent.setNoticeCount(result)
    },
    async load() {
      this.apply(await getChannelNotices())
    },
    async openRow(row) {
      this.current = row
      this.open = true
      if (!row.read && row.noticeKey) await this.mark(row)
    },
    async mark(row) {
      if (!row || !row.noticeKey || this.busy) return
      this.busy = true
      try {
        this.apply(await readChannelNotice({ noticeKey: row.noticeKey }))
      } finally {
        this.busy = false
      }
    },
    async markAll() {
      if (!this.unread || this.busy) return
      this.busy = true
      try {
        this.apply(await readChannelNotice({ all: true }))
      } finally {
        this.busy = false
      }
    }
  }
}
</script>

<style scoped>
.ch-click { cursor: pointer; }
.ch-unread { color: #1e2a78; }
.notice-body { margin: 12px 0 0; white-space: pre-wrap; line-height: 1.7; color: #24304a; }
</style>
